//eslint-disable-next-line
export default {
  xs: 0,
  sm: 600,
  md: 904,
  lg: 1239,
  xl: 1439
};
